import { PortfolioName } from '@/data/portfolio/portfolio-list-data';
import PortfolioBanner from './components/portfolio-banner';
import './portfolio-detail-page.scss';
import { useParams } from 'react-router-dom';
import { DETAIL_DATA } from '@/data/portfolio/portfolio-detail-data';
import PortfolioMockup from './components/portfolio-mockup';
import PortfolioProjectInfo from './components/portfolio-project-info';
import PortfolioFont from './components/portfolio-font';
import PortfolioColor from './components/portfolio-color';
import PortfolioContentImages from './components/portfolio-content-images';
import { Helmet } from 'react-helmet-async';
import PortfolioNextBanner from './components/portfolio-next-banner';
import NotFoundPage from '@/pages/404/not-found-page';

const PortfolioDetailPage = () => {
	const { name } = useParams() as { name: PortfolioName };

	const data = DETAIL_DATA[name];

	if (!data) {
		return <NotFoundPage />;
	}

	return (
		<div className="portfolio-detail-page-wrapper">
			<Helmet>
				<title>미스터디벨로 - {data.projectInfo.title}</title>
				<meta
					name="description"
					content={`미스터디벨로 포트폴리오 - ${data.projectInfo.title}`}
				/>
				<meta
					property="og:image"
					content={data.banner.backgroundImage}
				/>
				<meta property="og:url" content={`${window.location.href}`} />
				<meta
					property="og:title"
					content={`미스터디벨로 - ${data.projectInfo.title}`}
				/>
				<meta
					property="og:description"
					content={`미스터디벨로 포트폴리오 - ${data.projectInfo.title}`}
				/>
				<meta
					property="keywords"
					content={`미스터디벨로, 포트폴리오, ${data.projectInfo.title}`}
				/>
				<meta property="og:type" content="website" />
				<meta
					name="apple-mobile-web-app-title"
					content={`미스터디벨로 - ${data.projectInfo.title}`}
				/>
				<link
					rel="apple-touch-icon"
					href={data.banner.backgroundImage}
				/>
				<meta
					name="apple-mobile-web-app-title"
					content="미스터디벨로"
				/>
			</Helmet>
			<PortfolioBanner banner={data.banner} />
			<PortfolioMockup mockup={data.mockup} />
			<PortfolioProjectInfo projectInfo={data.projectInfo} />
			<PortfolioFont font={data.font} />
			<PortfolioColor color={data.color} />
			<PortfolioContentImages contentImages={data.contentImages} />
			<PortfolioNextBanner />
		</div>
	);
};

export default PortfolioDetailPage;
